@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-showAddFolder-button"
          [ngClass]="btnClass"
          [matTooltip]="title"
          [matTooltipDisabled]="isMatMenu"
          (click)="showAddFolderModal()">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-plus"></i>
    <label [hidden]="iconOnly" class="m-0">{{ title }}</label>
  </button>
} @else {
  <sk-button
             data-test="dms-showAddFolder-button"
             [appearance]="iconOnly ? 'icon' : 'text'"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="showAddFolderModal()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-plus"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-plus"></i>
      </ng-template>
    }
  </sk-button>
}
